import Hotkeys from './non-authed-hotkeys';

// Hotkeys component is same for both authed & unauthed pages
// Both currently only use CloseModalHotkey
// Update this when more hotkeys are added for auth page modals

export default Hotkeys;
